import React from 'react';
import { Container } from '@mantine/core';
import ExperienceProfessional from './Experience/Professional';
import ExperienceCurricular from './Experience/Curricular';

export default function Experience() {
  return (
    <Container>
      <ExperienceProfessional />
      <ExperienceCurricular />
    </Container>
  );
}
